import { defineMessages } from 'react-intl';

const scope = 'app.workspace.projects.importFileDropZone';

export default defineMessages({
  dragAndDropUploadMessage: {
    id: `${scope}.dragAndDropUploadMessage`,
    defaultMessage: 'Drag and drop your file here',
  },
  or: {
    id: `${scope}.or`,
    defaultMessage: 'or',
  },
  browseFile: {
    id: `${scope}.browseFile`,
    defaultMessage: 'Browse',
  },
  wrongFileFormat_EPUB_AMBROSIA: {
    id: `${scope}.wrongFileFormat_EPUB_AMBROSIA`,
    defaultMessage: 'Please choose an ambrosia file format',
  },
  wrongFileFormat_EPUB: {
    id: `${scope}.wrongFileFormat_EPUB`,
    defaultMessage: 'Please choose .epub file format',
  },
  wrongFileFormat_DOCX: {
    id: `${scope}.wrongFileFormat_DOCX`,
    defaultMessage: 'Please choose .docx file format',
  },
  wrongFileFormat_AMBROSIA: {
    id: `${scope}.wrongFileFormat_AMBROSIA`,
    defaultMessage: 'Please choose an ambrosia file format',
  },
});
